import React from 'react';
import { CnLayoutAside as UICnLayoutAside } from "../../components/cn-layout";
var CnLayoutAside = function CnLayoutAside(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutAside, null, children);
};
CnLayoutAside.displayName = 'CnLayoutAside';
CnLayoutAside.typeMark = 'Aside';
export default CnLayoutAside;
export { CnLayoutAside };